import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

Modal.setAppElement("#root");

function OpeFeedback() {
    const { DateTime } = require("luxon");
    const [lista, setlista] = useState([]);
    const [listacolaborador, setlistacolaborador] = useState([]);
    const [listasupervisor, setlistasupervisor] = useState([]);
    const [abusca, setabusca] = useState("");
    const [showform, setshowform] = useState(false);

    const [edtcodfeedback, setedtcodfeedback] = useState(0);
    const [edtpositivo, setedtpositivo] = useState("");
    const [edtcodsupervisor, setedtcodsupervisor] = useState(0);
    const [edtcodcolaborador, setedtcodcolaborador] = useState(0);
    const [edtfeedback, setedtfeedback] = useState("");

    const [edtcodequipe, setedtcodequipe] = useState(0);

    const [novo, setnovo] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    const { codassinante, selectedCompany, accessKey } = useAppContext(); 

    const handleOpen = (cad) => {
        setedtcodfeedback(cad.codfeedback);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        Excluir();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    function ListarFeedback() {

        api
            .get("/v1/operacoes/feedback", {
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    codassinante,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarFeedback();
        },
        [showform, abusca, selectedCompany]
    );

    function ListarSupervisor() {
        api
            .get("v1/operacoes/supervisorrh", {
                params: {
                    codassinante,
                    codempresa: selectedCompany
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlistasupervisor(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarColaborador() {
        api
            .get("v1/operacoes/colaboradorequipe", {
                params: {
                    codequipe: edtcodequipe
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlistacolaborador(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarColaborador();
        },
        [edtcodequipe]
    );

    function Cadastrar() {
        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        api
            .post(
                "/v1/operacoes/feedback",
                {
                    dtlancamento: dtcadastro,
                    positivo: edtpositivo,
                    codsupervisor: edtcodsupervisor,
                    codcolaborador: edtcodcolaborador,
                    feedback: edtfeedback,
                    excluido: "N",
                    codassinante,
                    codempresa: selectedCompany
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(function (response) {
                ListarFeedback();

                alert(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Editar() {
        api
            .put(
                "/v1/operacoes/feedback",
                {
                    positivo: edtpositivo,
                    codsupervisor: edtcodsupervisor,
                    codcolaborador: edtcodcolaborador,
                    feedback: edtfeedback,
                    codfeedback: edtcodfeedback
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarFeedback();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Excluir() {
        api
            .delete("/v1/operacoes/feedback", {
                params: {
                    codfeedback: edtcodfeedback
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarFeedback();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    function closeModal() {
        setshowform(false);
    }

    function openModalNovo() {
        setshowform(true);
        setnovo(true);

        setedtcodfeedback(0);

        setedtpositivo("S");
        setedtcodsupervisor(0);
        setedtcodcolaborador(0);
        setedtfeedback("");

        ListarSupervisor();
    }

    function openModalEditar(cad) {
        setshowform(true);
        setnovo(false);

        setedtcodfeedback(cad.codfeedback);

        setedtpositivo(cad.positivo);
        setedtcodsupervisor(cad.codsupervisor);
        setedtcodcolaborador(cad.codcolaborador);
        setedtfeedback(cad.feedback);

        ListarSupervisor();
    }

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    const handleSupervisorChange = (e) => {
        const selectedValue = parseInt(e.target.value, 10);
        const selectedSupervisor = listasupervisor.find(col => col.codsupervisor === selectedValue);

        if (selectedSupervisor) {
            setedtcodsupervisor(selectedSupervisor.codsupervisor);
            setedtcodequipe(selectedSupervisor.codequipe);
        }
    };

    const handleColaboradorChange = (event) => {
        setedtcodcolaborador(event.target.value); // Armazena "null" para todas as empresas
    };

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div>
                        <div>
                            <PopUp isOpen={isOpen} onClose={handleClose}>
                                <h2>Verificação</h2>
                                <p>Tem certeza que deseja excluir esse feedback?</p>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handleConfirma}
                                        >
                                            Sim
                                        </button>
                                        <button className="btn btn-danger" onClick={handleClose}>
                                            Não
                                        </button>
                                    </div>
                                </div>
                            </PopUp>
                        </div>

                        <Modal
                            isOpen={showform}
                            onRequestClose={closeModal}
                            overlayClassName="modal-overlay"
                            className="modal-content"
                        >
                            <div className="container-fluid h-100">
                                <div className="row">
                                    <h2>Novo Cadastro</h2>
                                </div>
                                <div className="row">
                                    <hr />
                                </div>

                                <div className="row">
                                    <form>
                                        <div className="row">                                            
                                            <div className="col-sm-2">
                                                <div>
                                                    <label htmlFor="positivo" className="form-label">
                                                        Positivo
                                                    </label>
                                                    <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="positivo"
                                                            value="S"
                                                            onChange={(e) => setedtpositivo(e.target.value)}
                                                            checked={edtpositivo === "S"}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                        >
                                                            Sim
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="positivo"
                                                            value="N"
                                                            onChange={(e) => setedtpositivo(e.target.value)}
                                                            checked={edtpositivo === "N"}
                                                        />
                                                        <label className="form-check-label">
                                                            Não
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5">
                                                <label htmlFor="colaborador" className="form-label">
                                                    Gestor
                                                </label>
                                                <select
                                                    className="form-select"
                                                    value={edtcodsupervisor}
                                                    onChange={handleSupervisorChange}
                                                >
                                                    <option value="0">Selecione o gestor</option>
                                                    {listasupervisor.map((col, index) => (
                                                        <option key={index} value={col.codsupervisor}>{col.nome}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-sm-5">
                                                <label htmlFor="colaborador" className="form-label">
                                                    Profissional
                                                </label>
                                                <select
                                                    className="form-select"
                                                    value={edtcodcolaborador}
                                                    onChange={handleColaboradorChange}
                                                >
                                                    <option value="0">Selecione o profissional</option>
                                                    {listacolaborador.map((col, index) => (
                                                        <option key={index} value={col.codfuncionario}>{col.nome}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row col-sm-12">
                                            <div className="col-sm-12">
                                                <label htmlFor="feedback" className="form-label">
                                                    Feedback
                                                </label>
                                                <input
                                                    type="text"
                                                    id="feedback"
                                                    className="form-control"
                                                    placeholder="Feedback"
                                                    value={edtfeedback}
                                                    onChange={(e) => setedtfeedback(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button className="btn btn-danger ms-4" onClick={closeModal}>
                                            Cancelar
                                        </button>
                                        <button className="btn btn-success ms-4" onClick={Salvar}>
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    <div className="row">
                        <h1 className="ms-4">Feedback</h1>
                        <p className="ms-4">Rotina para registrar os feedbacks dos gestores com os profissionais</p>
                        <hr />
                    </div>

                    <div className="row">
                        <div className="col-10">
                            <label className="d-block" htmlFor="busca">
                                Busque aqui
                            </label>
                            <input
                                type="text"
                                placeholder="Buscar por: Gestor ou profissional"
                                name="busca"
                                id="busca"
                                className="form-control me-3"
                                value={abusca}
                                onChange={(e) => setabusca(e.target.value)}
                            />
                        </div>

                        <div className="col-2 d-flex justify-content-center">
                            <button
                                className="btn btn-success btnnovo"
                                onClick={() => openModalNovo()}
                            >
                                Novo
                            </button>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <hr />
                    </div>

                    <div className="row">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Dt. Lançamento</th>
                                    <th>Positivo</th>
                                    <th>Gestor</th>
                                    <th>Profissional</th>
                                    <th>Feedback</th>
                                    <th className="acao">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map(function (item) {
                                    return (
                                        <tr key={item.codfeedback}>
                                            <th>{FormataDataHora(item.dtlancamento)}</th>
                                            <th>{item.positivo1}</th>
                                            <th>{item.supervisor}</th>
                                            <th>{item.colaborador}</th>
                                            <th>{item.feedback}</th>
                                            <th>
                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        className="btn fa-regular fa-pen-to-square"
                                                        onClick={() => openModalEditar(item)}
                                                    ></button>
                                                    <button
                                                        className="btn fa-solid fa-trash"
                                                        onClick={() => handleOpen(item)}
                                                    ></button>
                                                </div>
                                            </th>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={6}>Quantidade de Registros: {lista.length}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OpeFeedback;
